import React from 'react';
import './HomeButtons.css';
import { loginUrl } from '/home/ubuntu/disco-byngo/src/spotify-api-logic/spotify-api-logic.js';
import { Link } from 'react-router-dom';
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import axios from 'axios';

export function HomeButtons() {
    
    return(
        <div className="login">
            <a className="login-button" href='https://react-byngo-io.herokuapp.com/login'><AwesomeButton type="secondary" onPress={null} className="device-button" >CREATE NEW GAME</AwesomeButton></a>

            <h2>OR</h2>
            <Link to="/join"><div className="join-button"><AwesomeButton type="primary" onPress={null} className="device-button" >JOIN GAME</AwesomeButton></div></Link>
        </div>
    );
}

export default HomeButtons;